import React, { FC } from 'react';
import breakpoints from '../../../constants/breakpoints.constants';
import { iconSize } from '../../../constants/icon.constants';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { getImageField } from '../../../utils/getImageFields';
import { getThumbnailProps } from '../../../utils/youtube.utils';

import Picture from '../../@shared/picture';
import VideoPlayer from '../../@shared/videoPlayer';
import { TNewsDetailMedia } from '../types/newsDetail.types';

const NewsDetailMedia: FC<TNewsDetailMedia> = (props) => {
  const { desktopImage, mobileImage, showVideo, videoUrl } = props;

  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  if (videoUrl && showVideo) {
    const { thumbnailImgSrc } = getThumbnailProps(videoUrl);
    const desktopImageOrThumbnail = getImageField(desktopImage, thumbnailImgSrc || '', showVideo);
    const mobileImageOrThumbnail = getImageField(mobileImage, thumbnailImgSrc || '', showVideo);

    return (
      <div className="news-detail__media-wrapper news-detail__video">
        <VideoPlayer
          link={videoUrl}
          autoPlay={true}
          showThumbnail={true}
          videoPlayerWrapperClassName="news-detail__media--video"
          editorialImageProps={{
            desktopImage: desktopImageOrThumbnail,
            mobileImage: mobileImageOrThumbnail,
            isEditable: true,
            alt: `${isDesktop ? desktopImageOrThumbnail?.value?.alt : mobileImageOrThumbnail?.value?.alt}`,
          }}
          desktopPlayIconSize={iconSize.xxlg}
          mobilePlayIconSize={iconSize.dsk}
        />
      </div>
    );
  }

  return (
    <div className="news-detail__media-wrapper">
      <Picture
        editorialImageProps={{
          mobileImage: mobileImage,
          desktopImage: desktopImage,
          cssClassImageEl: 'news-detail__image',
          cssClassPictureEl: 'news-detail__image-wrapper',
          desktopTransformation: 'Size1000',
          mobileTransformation: 'Size1000',
        }}
      />
    </div>
  );
};

export default NewsDetailMedia;
